import React, { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import audioRecordService from '../../services/audio-record.service';

import ReactAudioPlayer from 'react-audio-player';

const STEP_NOT_INIT = 0;
const STEP_IDLE = 1;
const STEP_RECORDING = 2;
const STEP_RECORDED = 3;
const STEP_ENCODING = 4;

const TIMER_REFRESH_INTERVAL = 50; // ms
const RECORDING_BLINK_PERIOD = 1000; // ms

let timerInterval = null;

const AudioRecord = (props) => {

  /* State vars */

  /* step: 0: not init, 1: idle, 2: recording, 3: recorded */
  const [step, setStep] = useState(STEP_NOT_INIT);

  /* Counter: numbers already formatted */
  const [timerDisplayMinutes, setTimerDisplayMinutes] = useState('');
  const [timerDisplaySeconds, setTimerDisplaySeconds] = useState('');

  /* State of the recording led */
  const [litRecording, setLitRecording] = useState(false);

  /* Audio player */
  const [audioPlayerSource, setAudioPlayerSource] = useState('');

  /* Audio ref */
  const audioRef = useRef(null);

  /* Use effect */

  /* Run on step change */
  useEffect(() => {
    switch(step) {
      default: stepNotInit(); break;
      case STEP_IDLE: stepIdle(); break;
      case STEP_RECORDING: stepRecording(); break;
      case STEP_RECORDED: stepRecorded(); break;
      case STEP_ENCODING: stepEncoding(); break;
    }
  }, [step]);

  /* Run on video src change */
  // useEffect(() => {
  //   const audioEl = audioRef.current.audioEl.current;
  //   if (audioPlayerSource && isNaN(audioEl.duration)) {
  //     audioEl.currentTime = 1e99;
  //     audioEl.currentTime = 0;
  //     audioEl.onSeek = 0;
  //   }
  // }, [audioPlayerSource]);

  /* Step methods run after entering state */

  const stepNotInit = () => {
    audioRecordService.initRecorder().then((success) => {
      if (success) {
        setStep(STEP_IDLE);
      }
    });
  }

  const stepIdle = () => {
    refreshTimer();
    setAudioPlayerSource('');
  }

  const stepRecording = () => {
    audioRecordService.startRecording();
    if (timerInterval === null) {
      timerInterval = setInterval( () => {
        refreshTimer();
      }, TIMER_REFRESH_INTERVAL);
    }
  }

  const stepRecorded = () => {
    if (timerInterval !== null) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
    audioRecordService.stopRecording()
      .then(() => {
        setAudioPlayerSource(audioRecordService.getAudioUrl());
      });
    refreshTimer();
  }

  const stepEncoding = () => {
    console.log('step encoding');
    encodeAndSaveTempAudioFile().then((data) => {
      if (data) {
        document.location.href = props.afterSaveUrlPattern.replace(
          '{audio_id}', data.audioId);
      } else {
        alert('error');
      }
    });
  }

  /* Event handlers */

  const recordClickHandler = (e) => {
    setStep(STEP_RECORDING);
  }

  const stopClickHandler = (e) => {
    if (step == STEP_RECORDING) {
      setStep(STEP_RECORDED);
    }
  }

  const discardClickHandler = (e) => {
    setStep(STEP_IDLE);
  }

  const saveHandler = (e) => {
    setStep(STEP_ENCODING);
  }

  /* This is to fix Chrome bug not getting the durations */
  const audioLoadedMetadataHandler = (e) => {
    const audioEl = e.target;
    function seekedHandler(e) {
      audioEl.removeEventListener('seeked', seekedHandler);
      audioEl.currentTime = 0;
    }
    if (true || audioEl.duration === Infinity) {
      audioEl.addEventListener('seeked', seekedHandler);
      audioEl.currentTime = 1e8;
    }
  }

  /* Methods */

  const refreshTimer = () => {
    if (step === STEP_RECORDING || step === STEP_RECORDED) {
      const timerMilisec =  audioRecordService.getTimerMilisec();
      const timerSec = Math.floor(timerMilisec / 1000);
      setLitRecording(step === STEP_RECORDING &&
        timerMilisec % RECORDING_BLINK_PERIOD < RECORDING_BLINK_PERIOD / 2);
      setTimerDisplayMinutes(Math.floor(timerSec / 60).toString());
      setTimerDisplaySeconds((timerSec % 60).toString()
        .padStart(2, '0'));
    } else {
      setTimerDisplayMinutes('0');
      setTimerDisplaySeconds('00');
      setLitRecording(false);
    }
  }

  /* returns promise with temp file URL */
  const encodeAndSaveTempAudioFile = async () => {
    const audioData = await audioRecordService.getAudioDataAsRecorded();
    const response = await axios.post(props.saveFileUrl, {
      content: btoa(audioData.contents),
      ownerId: props.ownerId,
      durationSec: Math.round(audioRecordService.getTimerMilisec() / 1000),
      mimetype: audioData.mimetype,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  }

  /* Render */

  const enableDiscard = step === STEP_RECORDED;
  const showRecord = step === STEP_IDLE;
  const showStop = step === STEP_RECORDING;
  const enableSave = step === STEP_RECORDED;

  let startStopButton;
  if (showStop) {
    /* Note: no stop handler here because is attached to container */
    startStopButton = (
      <button className="btn start-stop-button">
        <i className="icon-audio-circle-stop"></i>
        <span>Stop</span>
      </button>
    );
  } else {
    startStopButton = (
      <button className="btn start-stop-button"
        disabled={!showRecord} onClick={recordClickHandler}>
        <i className="icon-audio-circle-record"></i>
        <span>Start</span>
      </button>
    );
  }

  let recordingClasses = ['recording'];
  if (step === STEP_RECORDING) {
    recordingClasses.push('step-recording');
  }

  let controlsOrSpinner;
  if (step === STEP_ENCODING) {
    controlsOrSpinner = (
      <div className="col-sm-12 col-spinner">
        <span className="spinner"></span>
      </div>
    );
  } else {
    controlsOrSpinner = (
      <Fragment>
        <div className="col-sm-4 col-status">
          <div className={recordingClasses.join(' ')}>Recording {litRecording ? <i className="icon-audio-circle-record"></i> : <i className="icon-audio-circle-empty"></i>}</div>
          <div className="time">
            {timerDisplayMinutes}:{timerDisplaySeconds}
          </div>
          <div className="discard">
            <button className="btn btn-outline-danger"
              disabled={!enableDiscard} onClick={discardClickHandler}>
              <i className="icon-bin"></i>
              Discard
            </button>
          </div>
        </div>
        <div className="col-sm-4 col-start-stop">
          {startStopButton}
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="row flex-grow-1 row-controls" onClick={stopClickHandler}>
        {controlsOrSpinner}
      </div>
      <div className="container-lg container-player-save">
        <div className="row flex-grow-0 align-items-center mb-2 row-player-save">
          <div className="col-12 col-sm flex-grow-1 col-audio-player ">
            <ReactAudioPlayer src={audioPlayerSource} controls ref={audioRef}
              onLoadedMetadata={audioLoadedMetadataHandler} />
          </div>
          <div className="col-12 col-sm-auto text-end col-buttons">
            <button className="btn btn-primary" disabled={!enableSave}
              onClick={saveHandler}>Save</button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

AudioRecord.propTypes = {
  ownerId: PropTypes.number.isRequired,
  saveFileUrl: PropTypes.string,
  afterSaveUrlPattern: PropTypes.string.isRequired,
};

export default AudioRecord;
